<template>
    <div
        class="even:bg-card-2 flex w-full items-center px-5 py-3"
        :class="isSoloGame ? 'justify-between' : ''"
    >
        <span
            v-if="!isSoloGame"
            class="min-w-0 flex-1 shrink text-center text-lg whitespace-nowrap text-white"
            :class="{ 'font-bold text-green-500!': betterPlayer === 1 }"
        >
            {{ displayValue(player1Value) }}
        </span>
        <span
            class="text-base font-bold whitespace-nowrap"
            :class="[isSoloGame ? 'order-1' : 'min-w-0 flex-1 shrink px-4 text-center']"
        >
            {{ label }}
        </span>
        <span
            class="min-w-0 flex-1 shrink text-center text-lg whitespace-nowrap text-white"
            :class="[
                isSoloGame ? 'order-2 font-bold' : '',
                {
                    'font-bold text-green-500!': !isSoloGame && betterPlayer === 2,
                    'text-end': isSoloGame,
                },
            ]"
        >
            {{ displayValue(isSoloGame ? player1Value : player2Value) }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'StatRow',
    props: {
        player1Value: {
            type: [Number, String],
            default: 0,
        },
        player2Value: {
            type: [Number, String],
            default: null,
        },
        label: {
            type: String,
            required: true,
        },
        isSoloGame: {
            type: Boolean,
            default: false,
        },
        lowerIsBetter: {
            type: Boolean,
            default: false,
        },
        noHighlight: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        betterPlayer() {
            if (this.noHighlight) return null
            // Values may be formatted strings ("12 darts", "45.20%"), so compare numerically
            const a = parseFloat(this.player1Value)
            const b = parseFloat(this.player2Value)
            if (Number.isNaN(a) || Number.isNaN(b) || a === b) return null
            return (this.lowerIsBetter ? a < b : a > b) ? 1 : 2
        },
    },
    methods: {
        displayValue(value) {
            if (value === null || value === undefined || value === '') {
                return '-'
            }
            return value
        },
    },
}
</script>
